(function ($) {



    // Related stories slider
    $('.slider-related').slick({
        accessibility: false,
        arrows: true,
        dots: true,
        infinite: false,
        lazyLoad: 'ondemand',
        slide: '.slider-item',
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    // Related stories slider
    $('.slider-crosssell').slick({
        accessibility: false,
        arrows: true,
        dots: true,
        infinite: false,
        lazyLoad: 'ondemand',
        slide: '.slider-item',
        slidesToShow: 4,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    // Full width image slider
    $('.slider-hero').slick({
        accessibility: false,
        arrows: true,
        dots: false,
        fade: true,
        infinite: false,
        lazyLoad: 'ondemand',
        slide: '.slider-item',
        slidesToShow: 1,
    })
        .on('afterChange', function (event, slick, currentSlide, nextSlide) {
            // $('.slider-hero img').removeClass('animated scaleIn');
            // $(this).find('.slick-current img').addClass('animated scaleIn');
        });


})(jQuery);
